import React, { useState, useEffect } from 'react';

export default function InstallBanner() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // 1. Detect iOS Safari (Apple blocks automatic install prompts)
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIosDevice = /iphone|ipad|ipod/.test(userAgent);
    const isStandalone = window.navigator.standalone === true; // true if already installed
    
    if (isIosDevice && !isStandalone) {
      setIsIOS(true);
      setShowBanner(true);
    }

    // 2. Detect Android/Chrome standard install prompt
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault(); // Stop the default mini-infobar from appearing
      setDeferredPrompt(e); // Save the event so we can trigger it later
      setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    
    // Show the native browser install prompt
    deferredPrompt.prompt();
    
    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      console.log('User accepted the install prompt');
    }
    
    // Clear the prompt and hide banner
    setDeferredPrompt(null);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '90%',
      maxWidth: '400px',
      backgroundColor: '#1a1a1a',
      color: 'white',
      padding: '15px 20px',
      borderRadius: '12px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      zIndex: 9999,
      border: '1px solid #333'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
        <div style={{ width: '40px', height: '40px', backgroundColor: '#007bff', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>
          📱
        </div>
        <div>
          <h4 style={{ margin: '0 0 2px 0', fontSize: '15px' }}>Get the Nundinaria App</h4>
          
          {isIOS ? (
            <p style={{ margin: 0, fontSize: '12px', color: '#aaa' }}>Tap <span style={{fontSize:'14px'}}>⍐</span> and select "Add to Home Screen"</p>
          ) : (
            <p style={{ margin: 0, fontSize: '12px', color: '#aaa' }}>Fast, native experience.</p>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {!isIOS && (
          <button 
            onClick={handleInstallClick}
            style={{ padding: '8px 16px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '50px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer' }}
          >
            Install
          </button>
        )}
        <button 
          onClick={() => setShowBanner(false)}
          style={{ background: 'none', border: 'none', color: '#888', fontSize: '20px', cursor: 'pointer', padding: '0 5px' }}
        >
          ×
        </button>
      </div>
    </div>
  );
}